import { Button, NonIdealState } from "@blueprintjs/core";
import { IconName, IconNames } from "@blueprintjs/icons";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import * as editActions from "core/actions/editActions";
import { PanelContext } from "core/decorators/Panel";
import initialState from "core/reducers/initialState";

/**
 * connected button for selecting things to edit.
 *
 * @author chris
 */

type EditTypes = 'panel' | 'view';

interface IEditToggleOwnProps {
	type: EditTypes;
	id?: string;
	instance: string;
}

interface IEditToggleDispatchProps {
	actions: typeof editActions;
}

type ResultProps = IEditToggleDispatchProps & IEditToggleOwnProps;

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IEditToggleDispatchProps {

	return {
		actions: bindActionCreators(editActions, dispatch)
	};
}

function editToggle(props: ResultProps) {

	const { type, instance, id } = props;

	return (
		<Button
			text="Edit"
			onClick={() => props.actions.editSetActive({ type, instance, id })}
		/>
	);
}

const EditToggle = connect(undefined, mapDispatchToProps)(editToggle);

export default EditToggle;

interface IPanelSetupRequiredProps {
	icon?: IconName;
	title?: string;
	description: string;
}

export const PanelSetupRequired: React.SFC<IPanelSetupRequiredProps> = ({description, icon, title}) => (
	<PanelContext.Consumer>
		{
			(ctx) => {
				if (!ctx || !ctx.editingEnabled) {
					return null;
				}

				return (
					<NonIdealState
						icon={icon || IconNames.WRENCH}
						title={title || "Setup Required"}
						description={description}
						action={
							<EditToggle type="panel" instance={ctx.instance} />
						}
					/>
				);
			}
		}
	</PanelContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/core/components/editor/EditToggle.tsx